import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
import { previewItems } from '../data/previewItems';
export function PreviewSection() {
  return <section aria-labelledby="preview-title" className="bg-brand-cream px-4 py-20 md:py-28" data-id="element-188" data-mp="223zfmeq140kt">
      <Reveal className="mx-auto max-w-content" data-id="element-189" data-mp="226bwspnyq6wt">
        <div className="mb-12 text-center" data-id="element-190" data-mp="2720t8k4or7ow">
          <p className="mb-3 text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand-accent" data-id="element-191" data-mp="274wx0p37sql9">
            NESSUNA SORPRESA
          </p>
          <h2 id="preview-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-192" data-mp="1x5xuzpcyft78">
            Guarda Cosa Ricevi. Davvero.
          </h2>
          <p className="mt-4 text-sm text-brand-gray md:text-base" data-id="element-193" data-mp="1netf8nfgg4bc">Pagine reali del pacchetto, non mockup.</p>
        </div>
        <ul className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-5" data-id="element-194" data-mp="19gczk6zm73h2">
          {previewItems.map(({
          image,
          alt,
          caption
        }) => <li key={caption} className="rounded-[18px] bg-brand-alt p-3 shadow-[0_10px_28px_rgba(11,60,93,0.07)]" data-id="element-195" data-mp="1edmwe7pc2hex">
              <div className="overflow-hidden rounded-[12px] bg-brand-cream" data-id="element-196" data-mp="2ctub1uut5rhn">
                <img src={image} alt={alt} loading="lazy" className="aspect-[4/5] w-full object-cover object-top" data-id="element-197" data-mp="27sn3nwwkuubi" />
              </div>
              <p className="px-1 pb-1 pt-3 text-center text-[11px] font-semibold leading-snug text-brand-gray md:text-xs" data-id="element-198" data-mp="2grs2z5fyqroq">
                {caption}
              </p>
            </li>)}
        </ul>
        <div className="mt-10 flex justify-center" data-id="element-199" data-mp="22ttpe29guzaa">
          <CTAButton className="w-full max-w-md md:w-auto" data-id="element-200" data-mp="22uli95boiiwv" />
        </div>
      </Reveal>
    </section>;
}